import s from "./Card.module.scss";
import imageBlog from "assets/images/imageBlog.webp";
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { ReactComponent as DeleteIcon } from "assets/icons/delete_image.svg";

import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import questionMark from "assets/images/questionMark.webp";
import {ModalGeneral} from "components/Modals/ModalGeneral";
import {useStatusContext} from "components/StatusProvider";
import {useDeleteBlogMutation} from "../../../redux/apis/blogApi";
import { ImageInput } from "components/ImageInput/ImageInput";
import { clearHTML } from "utils/clearHTML";
import { useNavigate } from "react-router-dom";


export const Card = ({id, title, body, image, author}: any ) => {
    const { t, i18n } = useTranslation();
    const { openStatus } = useStatusContext();
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [deleleBlog] = useDeleteBlogMutation();
    const navigate = useNavigate()

    const handleDelete = async () => {
        const result = await deleleBlog({id: id});

        if (result?.data?.message === "Blog delete successful") {
            openStatus('success', "status.operationSuccessful");
        } else {
            openStatus('error', "status.error");
        }
    }

    return (
        <div className={s.card}>
            <div className={s.image_wrapper}>
                <ImageInput 
                    values={image}
                    disabled={true}
                />
            </div>
            <h3 className={s.card_title}>{clearHTML(title)}</h3>
            <p className={s.card_description}>{clearHTML(body)}</p>

            {author ? <div className={s.card_author}>{author}</div> : null}
            <EditIcon className={s.card_edit} onClick={() => {navigate(`/blog/create?id=${id}`)}} />
            <DeleteIcon className={s.card_delete} onClick={() => setShowDeleteModal(true)}  />
            <ModalGeneral
                showModal={showDeleteModal}
                setShowModal={setShowDeleteModal}
                title={t("general.delete")}
                textLeftButton={t("general.cancel")}
                textRightButton={t("general.delete")}
                image={questionMark}
                description={`${t("general.areYouSure")}? ${t("general.itsContents")}`}
                buttonRight={handleDelete}
            />
        </div>
    )
}